import t from"react";const e={values:[]};export const CollapseContext=t.createContext(e);export const useCollapseContext=()=>t.useContext(CollapseContext);